export const DOC_TYPES = [
  { value: 'seguro', label: 'Seguro' },
  { value: 'ipva', label: 'IPVA' },
  { value: 'licenciamento', label: 'Licenciamento' },
  { value: 'crlv', label: 'CRLV' },
  { value: 'outro', label: 'Outro' },
] as const;

export const DOC_STATUSES = [
  { value: 'valid', label: 'Vigente' },
  { value: 'expiring', label: 'A vencer' },
  { value: 'expired', label: 'Vencido' },
  { value: 'paid', label: 'Pago' },
  { value: 'ok', label: 'OK' },
] as const;

export function docTypeLabel(type?: string | null): string {
  if (!type) return 'Outro';
  const found = DOC_TYPES.find(t => t.value === type);
  if (found) return found.label;
  const legacy: Record<string, string> = {
    other: 'Outro',
    insurance: 'Seguro',
    licensing: 'Licenciamento',
  };
  return legacy[type] || type;
}

export function docStatusLabel(status?: string | null): string {
  if (status === 'expired') return 'Vencido';
  if (status === 'expiring') return 'A vencer';
  if (status === 'paid') return 'Pago';
  if (status === 'valid') return 'Vigente';
  if (status === 'archived') return 'Arquivado';
  return 'OK';
}

export function docStatusTone(status?: string | null): 'green' | 'amber' | 'red' | 'slate' {
  if (status === 'expired') return 'red';
  if (status === 'expiring') return 'amber';
  if (status === 'paid' || status === 'ok') return 'green';
  return 'slate';
}

export function docStatusChipClass(status?: string | null): string {
  if (status === 'expired') return 'bg-red-100 text-red-800';
  if (status === 'expiring') return 'bg-amber-100 text-amber-800';
  if (status === 'paid' || status === 'ok') return 'bg-green-100 text-green-800';
  if (status === 'valid') return 'bg-slate-100 text-slate-700';
  return 'bg-slate-100 text-slate-600';
}

export function formatDocDate(dateStr?: string | null): string {
  if (!dateStr) return '—';
  return new Date(dateStr + (String(dateStr).includes('T') ? '' : 'T00:00:00')).toLocaleDateString(
    'pt-BR'
  );
}

export function formatFileSize(bytes?: number | null): string {
  if (bytes == null || Number.isNaN(bytes)) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function getFileAbsoluteUrl(path?: string | null): string {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080';
  return `${baseUrl}${path}`;
}

export const ACCEPTED_DOC_MIME = ['application/pdf', 'image/jpeg', 'image/png'];
export const ACCEPTED_DOC_EXT = ['.pdf', '.jpg', '.jpeg', '.png'];
export const MAX_DOC_FILE_MB = 10;

export function isAcceptedDocFile(file: File): boolean {
  const lower = file.name.toLowerCase();
  const byExt = ACCEPTED_DOC_EXT.some(ext => lower.endsWith(ext));
  const byMime = !file.type || ACCEPTED_DOC_MIME.includes(file.type);
  return byExt && byMime;
}
